module.exports = __webpack_public_path__ + "static/media/barcodeSelected.2cb47e12.svg";